import { render, staticRenderFns } from "./text-row-consume.vue?vue&type=template&id=7b43bccc&scoped=true&"
import script from "./text-row-consume.vue?vue&type=script&lang=js&"
export * from "./text-row-consume.vue?vue&type=script&lang=js&"
import style0 from "./text-row-consume.vue?vue&type=style&index=0&id=7b43bccc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b43bccc",
  null
  
)

export default component.exports